module.exports = __webpack_public_path__ + "static/media/DI.09113807.png";